/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/paperclip_medium'
export default icon
